<template>
  <div>
    <v-container text-xs-center :style="hScroller"> <!-- border: 3px solid black; -->
      <div v-if="bookingMode" id="bookie-selected-seats" :data-seat_ids="selectedSeatsIds" :data-Seat_names="selectedSeatsNames">
        Selected seats: {{ selectedSeatsNames }}
      </div>
      <table style="margin: 0 auto; padding-top: 10px; padding-bottom: 10px;  border: 1px solid rgba(66,66,66,0.55);">

        <tr>
          <td :colspan="mainCols" style="padding-left: 15px; padding-right: 15px;">
            <v-btn block outline :aria-disabled="true" style="margin-bottom: 70px;">
              <i><b>SCREEN</b></i>
            </v-btn>
          </td>
        </tr>

        <!-- Seats rendering -->
        <tr v-for="(fullRow, rowIndex) in groupedSeats">
          <td style="padding-left: 15px; padding-right: 15px;" :style="{ 'padding-bottom' : (rowIndex > 0 && (rowIndex + 1) % 5 === 0) ? '30px' : '' }">
            <table>
              <tr>
                <template v-for="(slot, slotIndex) in fullRow">
                  <td :style="{'padding-right': (slotIndex > 0 && (slotIndex + 1) % 14 === 0 && (slotIndex + 1) !== fullRow.length) ? '30px' : '' }">
                    <v-tooltip bottom>
                      <v-btn fab small color="primary"
                             class="mx-0" slot="activator"
                             :disabled="slot.booked"
                             style="margin: 0; padding: 0; height: 20px; width: 20px"
                             :outline="! slot.reserved"
                             @click="(event) => {seatSelected(event, slot)}"
                      >
                      </v-btn>
                      <span>{{ rowLetter(slot.y) + "-" + slot.x }}</span>
                    </v-tooltip>
                  </td>
                </template>
              </tr>
            </table>
          </td>
        </tr>
        <!-- End Seats rendering -->

      </table>
      <!-- Legend -->
      <div v-if="bookingMode">
        <v-container grid-list-md text-xs-center>
          <v-layout row wrap>
            <v-flex>
              <v-btn fab small color="primary" :aria-disabled="true"
                     class="mx-0" slot="activator"
                     style="margin: 0; padding: 0; height: 20px; width: 20px"
                     outline
              ></v-btn> Available &nbsp;
              <v-btn fab small color="primary" :aria-disabled="true"
                     class="mx-0" slot="activator"
                     outline
                     style="margin: 0; padding: 0; height: 20px; width: 20px"
                     disabled
              ></v-btn> Booked &nbsp;
              <v-btn fab small color="none" :aria-disabled="true"
                     class="mx-0" slot="activator"
                     outline
                     style="margin: 0; padding: 0; height: 20px; width: 20px"
                     disabled
              >
                <v-icon>build</v-icon>
              </v-btn> Under Repair &nbsp;
              <v-btn fab small color="primary" :aria-disabled="true"
                     class="mx-0" slot="activator"
                     style="margin: 0; padding: 0; height: 20px; width: 20px"
              ></v-btn> Selected (Reserved) &nbsp;
              <v-btn fab small color="teal" :aria-disabled="true"
                     class="mx-0" slot="activator" outline
                     style="margin: 0; padding: 0; height: 20px; width: 20px"
              >
                <v-icon style="margin-bottom: 3px;">star</v-icon>
              </v-btn> VIP &nbsp;
              <v-btn fab small color="purple" :aria-disabled="true"
                     class="mx-0" slot="activator" outline
                     style="margin: 0; padding: 0; height: 20px; width: 20px"
              >
                <v-icon style="margin-bottom: 3px;">accessible</v-icon>
              </v-btn> Wheelchair &nbsp;
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <!-- End Legend -->
    </v-container>
  </div>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    name: "Slots",

    props: {
      selectedLayout: Object,
      bookingMode: Boolean
    },

    data: () => ({
      seatsPerRow: 10
    }),

    methods: {
      rowLetter(rowNum) {
        let letter = '';
        let letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        if (rowNum > 0 && rowNum <= 26) {
          letter = letters[rowNum - 1];
        } else if (rowNum > 26) {
          letter = rowNum;
        }
        // if (rowNum === 1) {
        //   letter = "A"
        // } else if (rowNum === 2) {
        //   letter = "B"
        // } else if (rowNum === 3) {
        //   letter = "C"
        // } else if (rowNum === 4) {
        //   letter = "D"
        // } else if (rowNum === 5) {
        //   letter = "E"
        // } else if (rowNum === 6) {
        //   letter = "F"
        // } else if (rowNum === 7) {
        //   letter = "G"
        // } else if (rowNum === 8) {
        //   letter = "H"
        // } else if (rowNum === 9) {
        //   letter = "I"
        // } else if (rowNum === 10) {
        //   letter = "J"
        // } else if (rowNum === 11) {
        //   letter = "K"
        // } else if (rowNum === 12) {
        //   letter = "L"
        // } else if (rowNum === 13) {
        //   letter = "M"
        // } else if (rowNum === 14) {
        //   letter = "N"
        // } else if (rowNum === 15) {
        //   letter = "O"
        // } else if (rowNum === 16) {
        //   letter = "P"
        // } else if (rowNum === 17) {
        //   letter = "Q"
        // } else if (rowNum === 18) {
        //   letter = "R"
        // } else if (rowNum === 19) {
        //   letter = "S"
        // } else if (rowNum === 19) {
        //   letter = "T"
        // } else if (rowNum === 20) {
        //   letter = "U"
        // } else if (rowNum === 21) {
        //   letter = "V"
        // } else if (rowNum === 22) {
        //   letter = "W"
        // } else if (rowNum === 23) {
        //   letter = "X"
        // } else if (rowNum === 24) {
        //   letter = "Y"
        // } else if (rowNum === 25) {
        //   letter = "Z"
        // } else {
        //   letter = "";
        // }
        return letter;
      },
      seatSelected(event, slot) {
        if (this.bookingMode) {
          // emit the event to the parent component
          let slotIndex = this.selectedLayout.slots.indexOf(slot);
          // console.log(slotIndex);
          this.$emit('seat-selected', slotIndex);
        }
      }
    },

    computed: {
      capacity() {
        return (this.selectedLayout) ? this.selectedLayout.slots.length : 0;
      },
      aisles() {
        return (this.selectedLayout) ? this.selectedLayout.vSeparators : 0;
      },

      mainCols() {
        return this.aisles + 1;
      },

      selectedSeats() {
        let selectedSeats = [];
        let i = 0;
        for (i; i < this.capacity; i++) {
          let seat = this.selectedLayout.slots[i];
          if (seat.reserved) {
            selectedSeats.push(seat);
          }
        }
        return selectedSeats;
      },

      selectedSeatsNames() {
        // console.log('selected ' + this.selectedSeats.length);
        let seatNames = [];
        let i = 0;
        for (i; i < this.selectedSeats.length; i++) {
          let seatName = this.rowLetter(this.selectedSeats[i].y) + '-' + this.selectedSeats[i].x;
          seatNames.push(seatName);
        }
        return seatNames;
      },

      selectedSeatsIds() {
        // console.log('selected ' + this.selectedSeats.length);
        let seatIds = [];
        let i = 0;
        for (i; i < this.selectedSeats.length; i++) {
          seatIds.push(this.selectedSeats[i].id);
        }
        let responseArray = {"eventId": "bookieSeats", "seatIds": seatIds, "seatNames": this.selectedSeatsNames};
        window.parent.postMessage(responseArray, "*");
        return seatIds;
      },

      groupedSeats() {
        let groupedSeats = [];
        let fullRow = [];
        let rowCol = [];
        let currentRow = 0;
        let i = 0;

        for (i; i < this.capacity; i++) {

          // seat booked ?
          // this.selectedLayout.slots[i].booked = false;

          if (currentRow === 0) { //first iteration
            fullRow.push(this.selectedLayout.slots[i]);
            currentRow = this.selectedLayout.slots[i].y;
            if (i+1 === this.capacity) { //last slot (push rowCol to fullRow)
              groupedSeats.push(fullRow);
            }
          } else {
            if (currentRow === this.selectedLayout.slots[i].y) { //same row
              fullRow.push(this.selectedLayout.slots[i]);
              currentRow = this.selectedLayout.slots[i].y;
              if (i+1 === this.capacity) { //last slot (push rowCol to fullRow)
                groupedSeats.push(fullRow);
              }
            } else {
              groupedSeats.push(fullRow);
              currentRow = this.selectedLayout.slots[i].y;
              fullRow = [];
              fullRow.push(this.selectedLayout.slots[i]);
              if (i+1 === this.capacity) { //last slot (push rowCol to fullRow)
                groupedSeats.push(fullRow);
              }
            }
          }
        }

        return groupedSeats;
      },

      /* dynamic app styling */
      hScroller() {
        return (this.standAlonePage) ? '' : "overflow-x: scroll;";
      },

      /* map state from vuex */
      ...mapState([
        'standAlonePage'
      ])
    },

    created() {
      // console.log(this.standAlonePage);
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/resources/Slots.vue